import { Col, Container, Row, Spinner } from 'react-bootstrap';

export const LoaderContainer = () => {
  return (
    <Container fluid className="d-flex vh-100">
      <Row className="justify-content-center align-self-center w-100">
        <Col className="text-center">
          <Spinner animation="border" role="status" variant="primary" />
        </Col>
      </Row>
    </Container>
  );
};
